export default () => ({
  show: false,
  showCountry: false,
  showLanguage: false,
  country: null,
  language: null,
  redirects: [
    {
      name: "United States",
      value: "united states",
      url: "https://www.jlindebergusa.com/",
    },
  ],

  open() {
    this.show = true;
    Grebify.noScroll(true);
  },

  hide() {
    this.show = this.showCountry = this.showLanguage = false;
    Grebify.noScroll(false);
  },

  toggleCountry() {
    this.showCountry = !this.showCountry;
  },

  toggleLanguage() {
    this.showLanguage = !this.showLanguage;
  },

  setCountry(country, isRedirect) {
    if (isRedirect) {
      let clickedRedirect = this.redirects.filter(
        (redirect) => redirect.value === country
      );
      window.location.href = clickedRedirect[0].url;
    } else {
      setCookie("selectLocation", country, 14);
      this.country = country;
      this.$refs.countryForm.country_code.value = country;
      this.$refs.countryForm.submit();
    }
  },

  tracking() {
    if (Tracking) {
      const label = this.country + "_" + this.language;
      Tracking.interaction("Selector", "Select", label, 1);
    }
  },

  setLanguage(lang) {
    this.language = lang;
    this.$refs.languageForm.locale_code.value = lang;
    this.tracking();
    this.$refs.languageForm.submit();
  },

  appendRedirects(isMobile) {
    let countryLists = document.querySelectorAll("#CountryList");
    let countryList = isMobile ? countryLists[1] : countryLists[0];

    this.redirects.forEach((redirect) => {
      const li = document.createElement("li");
      li.className = "disclosure__item text-black-55 mb-4";
      li.tabIndex = -1;

      const a = document.createElement("a");
      a.href = "#";
      a.setAttribute(
        "x-on:click.prevent",
        `setCountry('${redirect["value"]}', true);`
      );
      a.innerHTML = redirect["name"];

      li.appendChild(a);
      countryList.appendChild(li);
    });
  },
});
